import { render, staticRenderFns } from "./daliyRecord.vue?vue&type=template&id=241647fe&scoped=true"
import script from "./daliyRecord.vue?vue&type=script&lang=js"
export * from "./daliyRecord.vue?vue&type=script&lang=js"
import style0 from "./daliyRecord.vue?vue&type=style&index=0&id=241647fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241647fe",
  null
  
)

export default component.exports